import React from 'react';
import { motion } from 'framer-motion';

// Dynamic exit options component for room endings
// Takes the available exit options from the scene config
const RoomEndChoice = ({ options = [], onSelect }) => {
  // Map option IDs to display labels
  const labelMap = {
    feel: 'Feel',
    weigh: 'Weigh',
    translate: 'Translate',
    close: 'Close'
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 2.5, ease: [0.25, 0.1, 0.25, 1] }}
      className="fixed bottom-28 sm:bottom-32 left-0 right-0 flex flex-col items-center z-20 px-6"
    >
      {/* Exit choices */}
      <div className="flex flex-row items-center gap-10 sm:gap-14">
        {options.map((optionId, index) => (
          <motion.button
            key={optionId}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ 
              duration: 2, 
              delay: 1 + index * 0.4,
              ease: [0.25, 0.1, 0.25, 1]
            }}
            onClick={() => onSelect(optionId)}
            className="group relative px-4 py-2 transition-all duration-1000"
          >
            <span 
              className="font-display text-lg sm:text-xl tracking-[0.15em] transition-all duration-1000 group-hover:tracking-[0.2em]"
              style={{ color: 'hsl(40, 10%, 55%)' }}
            >
              {labelMap[optionId] || optionId}
            </span>
            
            {/* Subtle underline on hover */}
            <motion.div
              className="absolute bottom-1 left-1/2 -translate-x-1/2 h-px opacity-0 group-hover:opacity-30 transition-opacity duration-1000"
              style={{ 
                width: '80%',
                backgroundColor: 'hsl(38, 20%, 50%)'
              }}
            />
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default RoomEndChoice;
